__turbopack_context__.v({
  "tooltipTrigger": "TooltipTrigger-module__55TtCG__tooltipTrigger",
});
